export default __webpack_public_path__ + "static/business-200e76ddf8652e4c064d35dd5654efc1.png";